module.exports = __webpack_public_path__ + "static/media/streamline-icon-calendar@140x140.f1160fbf.svg";